export const OrderEvent = {
    ORDER_COMPLETED: 'ORDER_COMPLETED',
    ORDER_STARTED: 'ORDER_STARTED',
    CHECKOUT_STARTED: 'CHECKOUT_STARTED',
    PRODUCT_VIEWED: 'PRODUCT_VIEWED',
    SEARCH_MENU: 'SEARCH_MENU',
    CHECKOUT_ATTEMPTED: 'CHECKOUT_ATTEMPTED',
};